import { getClaimDetails, resetClaim } from 'feature/claims/claimSlice';
import { useDispatch, useSelector } from 'react-redux';

import ClaimDetails from 'components/ViewClaimDetails/ClaimDetails.component';
import { getComplaintTrackingDetail } from 'feature/complaintTracking/complaintTrackingSlice';
import { getFraudTrackingDetail } from 'feature/fraudTracking/fraudTrackingSlice';
import { useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { AppDispatch, RootState } from 'store/store';

const ViewClaimDetails = () => {
	const param = useParams<{ uuid: string }>();
	const dispatch = useDispatch<AppDispatch>();
	const { reloadData } = useSelector((store: RootState) => store.claim);

	// Tracks the last claim we loaded so we can tell a navigation (uuid change)
	// apart from an in-place refresh (reloadData toggled) inside one effect.
	const prevUuid = useRef<string | undefined>(undefined);

	useEffect(() => {
		const uuid = param.uuid as string;
		const isNavigation = prevUuid.current !== uuid;
		prevUuid.current = uuid;

		// Only reset when switching to a different claim (or on first mount).
		// On an in-place refresh (reloadData toggled) skip the reset so
		// claimUUID stays set and the view doesn't blank out.
		if (isNavigation) {
			dispatch(resetClaim());
		}

		dispatch(getClaimDetails(uuid));
		dispatch(getComplaintTrackingDetail({ uuid }));
		dispatch(getFraudTrackingDetail({ uuid }));
	}, [dispatch, param.uuid, reloadData]);

	return <ClaimDetails />;
};

export default ViewClaimDetails;
